<template>
<div class="pamenty-body">
	<div id="pamentyWrapper" class="pamenty-box" :class="{ 'tw-box' : siteName == 'signet' }">
		<!-- Payment Authorization 待确认 -->
		<div class="authorization-box" v-if="paymentData && !submittedSuccessfully">
			<h2 class="credit-text credit-title">
				<span v-if="paymentData.paymentAmountType === '1'">Deposit</span>
				<span v-if="paymentData.paymentAmountType === '2'">Balance</span>
				<span v-if="paymentData.paymentAmountType === '3'">Full Payment</span>
        <span v-if="paymentData.paymentAmountType === '4'">Debit Payment</span>
				Authorization
			</h2>
      
			<div v-if="paymentMethod">
				<!--/* Payment for */-->
				<div class="booking-box">
          <div class="top-information d-flex">
            <a-row :gutter="8" style="flex: 1">
              <a-col :lg="7" :md="12" :xs="24">
                <div>
                  <strong>Booking No.:</strong>
                  <span>{{ paymentData.bookingNo }}</span>
                </div>
              </a-col>
              <a-col :lg="7" :md="12" :xs="24">
                <div>
                  <strong>Tour Code:</strong>
                  <span>{{ paymentData.tourCode }}</span>
                </div>
              </a-col>
            </a-row>
            <div class="operating" @click="operatingInstructions">{{siteName === 'signet' ? '付款操作說明' : 'Payment Instructions'}}<a-icon type="question-circle" /></div>
          </div>
          <div class="paid-payment-box" v-if="paymentData.payHistorys && paymentData.payHistorys.length > 0">
            <strong class="title">Payment(s) History:</strong>
            <div class="nr-table">
              <a-table
                size="small"
                :columns="columns"
                :data-source="datas"
                :pagination="false"
              >
                <span slot="serial" slot-scope="text, record, index">
                  {{ index + 1 }}
                </span>
                <div slot="custs" slot-scope="text, record">
                  <div v-for="cust in record.custs" :key="cust.bkcId">
                    {{ cust.bkcLName }}, {{ cust.bkcFName }}
                  </div>
                </div>
                <span slot="totalPrice" slot-scope="text, record">
                  {{websiteType == 'USA' ? '$' : 'CAD'}}{{ record.totalPrice }}
                </span>
              </a-table>
            </div>
          </div>
          <div class="payment-for d-flex">
            <strong :class="paymentData.paymentAmountType === '2' ? 'remaining-balance' : ''">I am paying for:</strong>
            <div v-if="paymentData.customers" style="flex:1">
              <div>
                <a-select
                  :showSearch="true"
                  :dropdown-match-select-width="false"
                  ref="specialRequestComponent"
                  mode="multiple"
                  :showArrow="true"
                  placeholder="Please select"
                  @change="paymentName"
                  v-model="selectedCustomers"
                  :disabled="paymentTypeNumber"
                >
                  <a-select-option v-if="numberLengthAll > 1" :disabled="selectedCustomersAll" value="All">
                    All
                  </a-select-option>
                  <a-select-option :disabled="selectedCustomersList" v-for="item in paymentData.customerList" :key="`${item.bkcId}`" :value="item.bkcId">
                    {{ item.lastName }}, {{ item.firstName }}
                  </a-select-option>
                </a-select>
                <div class="err" v-if="errPaymentName">Please select</div>
              </div>
            </div>
          </div>
          <div :class="(paymentData.paymentAmountType === '2' || paymentData.paymentAmountType === '3') && allAmountShow ? 'd-flex amount-box' : 'd-flex'">
            <strong v-if="paymentData.paymentAmountType === '2'" class="remaining-balance">Remaining Balance:</strong>
            <strong v-else>Amount:</strong>
            <div :class="websiteType == 'USA' ? 'payment-amount-number usa' : 'payment-amount-number can'" v-if="(paymentData.paymentAmountType === '2' || paymentData.paymentAmountType === '3') && allAmountShow">
              <span class="type">{{ websiteType == 'USA' ? '$' : 'CAD' }}</span>
              <a-input-number
                v-model="amountManual"
                @change="amountManualChange"
                :precision="0"
                :min="1"
                :max="Number(discountPrice)"
              />
              <div class="err" v-if="errBalanceSeparateAmount">Please enter the amount</div>
            </div>
            <span v-else>{{ websiteType == 'USA' ? '$' : 'CAD' }}{{ amount }}</span>
          </div>
          <div style="padding-bottom: 0;font-size: 1rem">If you have any questions about the amounts, please contact us.</div>
				</div>
			</div>
      <div class="check-payment-box">
        <strong>Payment method:</strong>
        <template v-if="paymentData.checkDiscount">
          <span style="color: #000;font-size: 1rem;" >Check Only</span>
          <span class="credit-text" style="margin-left: 10px;font-size: 1rem;">(Check payment only and 2% discount unavailable for this tour)</span>
        </template>
        <template v-if="!paymentData.checkDiscount" >
          <a-radio-group v-model="paymentMethod" @change="handleCheckPaymentMethodChange">
            <a-radio :value="1">Credit Card</a-radio>
            <a-radio :value="2">Check</a-radio>
          </a-radio-group>
        </template>
      </div>
      <div>
        <!-- USA -->
        <div v-if="paymentMethod === 2 && websiteType == 'USA'" class="check-payment-box check-box">
          <p>
            Payable to “{{ siteName == 'signet' ? 'Signet Tours' : 'Supera Tours' }}” with
            <strong>booking number</strong>
          </p>
          <a-radio-group v-model="checkPaymentMethod">
            <a-radio :value="1" label="" :class="checkPaymentMethod === 1 ? 'radio-the-check' : ''">
              <div class="upload-box">
                <div class="item" v-for="(cp, cpIndex) in checkPictureFiles" :key="`checkPictureFile-${cpIndex}`">
                  <a-button class="upload-btn" @click="handleUploadBtnClick(cpIndex)" v-if="checkPaymentMethod === 1">Upload your check</a-button>
                  <a-button
                    id="takePicture"
                    class="upload-btn"
                    @click="handleTakePictureBtnClick(cpIndex)"
                    v-if="checkPaymentMethod === 1"
                  >Take picture</a-button>
                  <input
                    style="display: none"
                    type="file"
                    :id="`uploadInput${cpIndex}`"
                    accept="image/png, image/jpeg, image/jpg"
                    capture="camera"
                    @change="handleUploadFileChange(cpIndex, $event)"
                  >
                  <template v-if="cpIndex === 0 && checkPaymentMethod !== 1">your check</template>
                  <template v-if="checkPaymentMethod === 1">
                    <a href="javascript:void(0)" v-if="cpIndex === (checkPictureFiles.length -1) && cpIndex < 2" @click="addCheckPictureFile" class="upload-icon"><a-icon type="plus" /></a>
                    <a href="javascript:void(0)" v-if="cpIndex > 0" @click="removeCheckPictureFile(cpIndex)" class="upload-icon"><a-icon type="delete" /></a>
                  </template>
                  <div v-if="checkPaymentMethod === 1" class="upload-name">
                    <span v-if="cp.uploadFileObject">{{ cp.uploadFileObject.name }}</span>
                    <span v-if="cp.uploadErr" class="err">Please upload the picture</span>
                    <span v-if="cp.uploadErrType" class="err">Please upload JPG or PNG</span>
                  </div>
                </div>
              </div>
            </a-radio>
            <a-radio
              :value="2"
            ><strong>OR</strong> mail to:{{ websiteType == 'USA' ? '1170 Durfee Ave. Suite E, South El Monte, CA 91733' : '2F, 4705B Hastings Street, Burnaby, BC, V5C 2K8' }}</a-radio>
          </a-radio-group>
        </div>
        <!-- CAN -->
        <div v-if="paymentMethod === 2 && websiteType != 'USA'" class="check-payment-box check-box">
          <p class="credit-text">
            Please contact us at <strong>877-688-7922</strong> instead of online payment submission.
          </p>
        </div>
      </div>
      <div class="form-box">
        <!--/* Card number */-->
        <a-form :form="formCreditCard">
          <div v-if="paymentMethod === 1" style="padding-top: 20px">
            <a-row :gutter="8">
              <a-col :md="10" :sm="24" :xs="24" class="card-number-box">
                <a-form-item
                  label="Card number"
                  :label-col="{ lg: 7, md:24}"
                  :wrapper-col="{ lg:17, md:24 }"
                >
                  <a-input
                    class="card-number-input"
                    :max-length="maxLengthsCardNumber"
                    @keypress="handleNumberChange"
                    v-decorator="[
                    'cardNumber',
                    { rules: [{ required: true, message: 'Please input Card number' }] },
                    { initialValue: '' }]"
                  />
                </a-form-item>
                <a-row class="log-row">
                  <a-col :span="7"></a-col>
                  <a-col :md="17" :sm="24" :xs="24">
                    <div class="log">
                      {{ log }}
                    </div>
                  </a-col>
                </a-row>
                <a-row class="number-row">
                  <a-col :span="7"></a-col>
                  <a-col :md="17" :sm="24" :xs="24">
                    <div class="">(We accept: Visa, Mastercard & American Express)</div>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <!--/* Exp date */-->
            <a-row :gutter="8">
              <a-col :md="7" :sm="24" :xs="24" :class="cardDateBox ? '' : 'card-date-box'">
                <a-form-item :label-col="{ lg: 10, md:24 }" :wrapper-col="{ lg: 14, md:24 }">
                  <div
                    style="display: inline-block"
                    slot="label"
                    class="ant-form-item-required required"
                  >Exp date</div>
                  <a-input
                    :class="cardDateBox ? '' : 'active'"
                    placeholder="mm/yy"
                    oninput="if(value.length>5)value=value.slice(0,5)"
                    @keypress="handleDateChange"
                    v-decorator="[
                      'expDate',
                      { rules: [{ required: false, message: 'Please input Exp date' }] },
                      { initialValue: '' }]"
                  />
                </a-form-item>
                <a-row class="exp-date-box">
                  <a-col :span="10"></a-col>
                  <a-col :span="14">
                    <div class="expDateErr">{{ expDateErr }}</div>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <!--/* Name on card */-->
            <a-row :gutter="8">
              <a-col :md="10" :sm="24" :xs="24">
                <a-form-item
                  label="Name on card"
                  :label-col="{ lg: 7,md:24 }"
                  :wrapper-col="{ lg: 17,md:24 }"
                >
                  <a-input
                    v-decorator="[
                      'nameOnCard',
                      { rules: [{ required: true, message: 'Please input Name on card' }] },
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <a-row :gutter="8" v-if="paymentMethod === 1">
            <a-col :span="24">
              <div class="must-read">
                <p>To protect you as a cardholder, {{ siteName == 'signet' ? 'Signet Tours' : 'Supera Tours' }} Inc (Supernet Tours) can only accept card payments for the passenger who is traveling & immediate family members.</p>
                <p>
                  <a-checkbox
                    @change="onChange1"
                    :class="(!checkedCard && !firstCheckedCard) ? 'show-notice' : ''"
                  >
                    <strong>Credit card transactions may be split into separate charges and may be billed under your respective airline and/or “Supernet Tours”, “Agent Fee”, or “Airlines Reporting Corporation”. Your credit card company may contact you to verify your transaction. </strong>
                  </a-checkbox>
                  <span v-if="!checkedCard && !firstCheckedCard" style="color:red">*Please check box to proceed</span>
                </p>
                <p>
                  <a-checkbox
                    @change="onChange"
                    :class="(!checked && !firstChecked) ? 'show-notice' : ''"
                  >I the undersigned, AS THE TRAVELER, authorize {{ siteName == 'signet' ? 'Signet Tours' : 'Supera Tours' }} Inc, a wholesale tour operator acting on my behalf or through instructions given to my travel agent, to apply charges to the following credit card, for travel and travel related services, for me (the undersigned) and for the following named persons mentioned below traveling on the same departure date and the same tour as me. If any chargeback or dispute arises from my charge, I will be fully responsible for the payment and will hold {{ siteName == 'signet' ? 'Signet Tours' : 'Supera Tours' }} Inc harmless from any amount that is charged back or disputed. All chargebacks or disputed amounts must be paid back to {{ siteName == 'signet' ? 'Signet Tours' : 'Supera Tours' }} Inc. promptly. This letter also waives and indemnifies {{ siteName == 'signet' ? 'Signet Tours' : 'Supera Tours' }} Inc. from any harm or occurrence from the above referenced chargeback. I understand and accept that airline tickets may or may not be issued against my credit card at the discretion of {{ siteName == 'signet' ? 'Signet Tours' : 'Supera Tours' }} Inc.</a-checkbox>
                  <span v-if="!checked && !firstChecked" style="color:red">*Please check box to proceed</span>
                </p>
              </div>
            </a-col>
          </a-row>
        </a-form>
        <div class="radio-check-box" v-show="(showInsurance || paymentData.paymentAmountType === '1') && websiteType == 'USA'">
          <div>
            <div v-if="siteName == 'signet'">我充分了解超值旅遊行程僅含旅行期間緊急醫療保險，其它狀況所產生的費用，須由旅客自行負擔。建議您可加購<a style="text-decoration: underline;padding:0;" target="_blank" class="agree_a" href="https://www.signettours.com/insurance/#basic_coverage">旅遊綜合保險</a>，此保險如首次付款後<span style="color: red;"> 21 天</span>內購買，投保人的既往病史<strong>(Pre-existing conditions)</strong>將被承保，之後不在保險範圍內。另外<strong> Cancel for Any Reason 的保險</strong>，必須在首次付款後<span style="color: red;"> 21 天</span>內購買，此保險不適用NY和WA的居民。</div>
            <div v-else>I am aware Supera includes complimentary basic insurance for <strong>Emergency Medical</strong> ONLY, and we will be responsible for our own expenses if unexpected disruptions occur before or during travels. Supera Tours strongly suggests the purchase of a comprehensive protection plan. Friendly reminder: Certain coverages such as pre-existing conditions or Cancel for Any Reason (“CFAR” - not available for NY and WA residents) are only available within 21 days of deposit or first tour payment. For details, please see our <a style="text-decoration: underline;padding:0;" target="_blank" class="agree_a" href="https://www.superatours.com/travel-insurance/">website</a>.</div>
          </div>
          <a-radio-group v-model="ifSendEmail" @change="handleRadioChange">
            <a-radio :value="1">
              {{ siteName == 'signet' ? '請聯絡我' : 'We need assistance. Please contact us.' }}
            </a-radio>
            <a-radio :value="0">
              {{ siteName == 'signet' ? '我(們)自己處理' : 'will arrange our own plan.' }}
            </a-radio>
            <div v-if="checkError" style="color: red;">Please select</div>
          </a-radio-group>
        </div>
        <!--/* Btn */-->
        <a-form-item>
          <div class="must-read"></div>
          <div class="d-flex justify-content-center">
            <div class="btn-box btn main-tonal-bj btn-tonal">
              <a-button type="primary" class="btn-box" :loading="submitting" @click="handlSubmit">SUBMIT</a-button>
            </div>
          </div>
        </a-form-item>
      </div>
      <!-- <div class="d-flex justify-content-center" style="padding-top:80px;">
        <div class="btn-box btn main-tonal-bj btn-tonal" style="margin-right:20px;">
          <a-button type="primary" class="btn-box" :loading="paymentTypeLoading" @click="separateType">分開支付</a-button>
        </div>
        <div class="btn-box btn main-tonal-bj btn-tonal">
          <a-button type="primary" class="btn-box" :loading="paymentTypeLoading" @click="wholeType">全額支付</a-button>
        </div>
      </div> -->
		</div>
		<!-- Payment Authorization 提交后成功页面 -->
		<div class="authorization-box submitted-successfully" v-if="paymentData && paymentData.paymentStatus !== 'TS' && submittedSuccessfully">
			<h2 class="credit-text credit-title" style="border-bottom: 1px solid #ddd;padding-bottom: 20px;">
				<span v-if="paymentData.paymentAmountType === '1'">Deposit</span>
				<span v-if="paymentData.paymentAmountType === '2'">Balance</span>
				<span v-if="paymentData.paymentAmountType === '3'">Full Payment</span>
        <span v-if="paymentData.paymentAmountType === '4'">Debit Payment</span>
				Authorization
			</h2>
			<h4 v-if="siteName === 'signet'">
        <!-- <span>您的付款信息已經提交，我們收到款項之後，系統會發送更新郵件給您！</span> -->
        <span style="line-height: 46px;" v-if="paymentData.paymentAmountType === '1' && (paymentData.amount <= 0 || paymentData.discountAmount <= 0)">
          此訂單已付完了訂金，請您在收到餘款提醒郵件後再來繼續支付。<br/>
          如有任何問題，歡迎隨時聯絡。謝謝！
        </span>
				<span style="line-height: 46px;" v-else-if="(paymentData.paymentAmountType === '2' || paymentData.paymentAmountType === '3') && (paymentData.amount <= 0 || paymentData.discountAmount <= 0)">
          目前您的團款都已結清，感謝您的支持，訂單如需增加其他費用請聯絡客服！<br/>
          超值旅遊將提供給您一個精彩、難忘的旅程！
        </span>
        <span v-else>您的付款信息已經提交，我們收到款項之後，系統會發送更新郵件給您！</span>
        <div class="paymen-info-box" v-if="formOfPaymentcc">
          <a-checkbox default-checked disabled />*以信用卡付費，帳單上可能分為幾筆交易，請款商家名稱為Supernet Tours（超值旅遊）、ARC（Airlines Reporting Corporation）或Agent Fee其一，敬請知悉。您的信用卡公司可能會聯繫您以驗證您的交易。任何使用信用卡付費後的退款，超值旅遊將收取2% 信用卡服務費。
        </div>
      </h4>
      <h4 v-else>
        Your payment has been submitted. Thank you! Once we process your payment, we will send you an update.
        <div class="paymen-info-box" v-if="formOfPaymentcc">
          <a-checkbox default-checked disabled />*Credit card transactions may be split into separate charges and will appear as “Supernet Tours”, “Agent Fee”, and/or “Airlines Reporting Corporation”. Your credit card company may contact you to verify your transaction. Refunds on credit cards will be charged a 2% merchant fee.
        </div>
      </h4>
      <p style="margin-bottom: 5px" class="credit-text phone-text" v-if="paymentData.paymentType === '4' && websiteType != 'USA'">
        Please contact us at <strong>877-688-7922</strong> instead of online payment submission.
      </p>
      <!-- <div class="d-flex justify-content-center" style="margin-top: 60px;">
        <div class="btn-box btn main-tonal-bj btn-tonal">
          <a-button type="primary" class="btn-box" :loading="continueLoading" @click="continuePayment">CONTINUE PAYMENT</a-button>
        </div>
      </div> -->
		</div>

    <div class="authorization-box submitted-successfully" v-if="paymentData && paymentData.paymentStatus === 'TS' && submittedSuccessfully">
			<h2 class="credit-text credit-title" style="border-bottom: 1px solid #ddd;padding-bottom: 20px;">
				<span v-if="paymentData.paymentAmountType === '1'">Deposit</span>
				<span v-if="paymentData.paymentAmountType === '2'">Balance</span>
				<span v-if="paymentData.paymentAmountType === '3'">Full Payment</span>
        <span v-if="paymentData.paymentAmountType === '4'">Debit Payment</span>
				Authorization
			</h2>
			<h4 v-if="siteName === 'signet'">因此訂單尚未完成配房，暫時不能線上付款，如有疑問請聯繫我們。</h4>
      <h4 v-else>Because this booking has not yet completed the share room,therefore online payment is not available,when you have questions please contact us.</h4>
      <p style="margin-bottom: 5px" class="credit-text phone-text" v-if="paymentData.paymentType === '4' && websiteType != 'USA'">
        Please contact us at <strong>877-688-7922</strong> instead of online payment submission.
      </p>
      <!-- <div class="d-flex justify-content-center" style="margin-top: 60px;">
        <div class="btn-box btn main-tonal-bj btn-tonal">
          <a-button type="primary" class="btn-box" :loading="continueLoading" @click="continuePayment">CONTINUE PAYMENT</a-button>
        </div>
      </div> -->
		</div>

	</div>
  <!-- Credit Card -->
  <a-modal
    v-model="creditCardModal" 
    ok-text="Yes" 
    cancel-text="No" 
    :maskClosable="false"
    @ok="hideModal" 
    @cancel="cancelModal"
  >
    <div slot="title">
      <span v-if="paymentData && paymentData.paymentAmountType === '3'">You choose credit card payment</span>
      <span v-else>Your deposit is paid by check</span>
    </div>

    <p v-if="paymentData && paymentData.paymentAmountType === '3'">The 2% discount of check payment will be removed.</p>
    <p v-else>Are you sure the balance changed to a credit card payment, the 2% discount will be removed.</p>
  </a-modal>

  <!-- Check -->
  <a-modal
    v-model="checkModal" 
    ok-text="Yes" 
    cancel-text="No" 
    :maskClosable="false"
    @ok="checkHideModal" 
    @cancel="checkcancelModal"
  >
    <div slot="title">
      <span>You choose check payment</span>
    </div>
    <p>The 2% discount of check payment will be applied.</p>
  </a-modal>

  <!-- 客人未选完 提示 -->
  <a-modal
    v-model="guestLengthTips" 
    ok-text="Yes" 
    cancel-text="No" 
    :maskClosable="false"
    @ok="tipsModal" 
    @cancel="tipsCancelModal"
  >
    <div slot="title">Continue to pay other guest(s)?</div>
    <div>
      <p :class="siteName === 'signet' ? 'guest-name-item tw' : 'guest-name-item en'">
        <span v-if="siteName === 'signet'">
          貴賓 
          <template v-if="paymentData && paymentData.paymentAmountType === '1'"><span v-for="r in noPayCusts" :key="r.bkcId">{{ r.bkcLName }}, {{ r.bkcFName }}</span></template>
          <template v-if="paymentData && paymentData.paymentAmountType !== '1'"><span v-for="c in noPayCustomerList" :key="c.bkcId">{{ c.lastName }}, {{ c.firstName }}</span></template>
           尚有團費仍未支付，是否繼續付款？
        </span>
        <span v-else>
          Guests 
          <template v-if="paymentData && paymentData.paymentAmountType === '1'"><span v-for="r in noPayCusts" :key="r.bkcId"> {{ r.bkcLName }}, {{ r.bkcFName }} </span></template>
          <template v-if="paymentData && paymentData.paymentAmountType !== '1'"><span v-for="c in noPayCustomerList" :key="c.bkcId">{{ c.lastName }}, {{ c.firstName }}</span></template>
           still have unpaid tour fees, would you like to pay for them now?
        </span>
      </p>
    </div>
  </a-modal>

  <!-- 客人正在提交 提示 -->
  <a-modal
    v-model="submissionTipModal" 
    :class="siteName === 'signet' ? 'submission-modal-box sig-box' : 'submission-modal-box sup-box'"
    :footer="null"
    :maskClosable="false"
    :title="false"
    :closable="false"
    :dialog-style="{ top: '200px' }"
  >
    <div class="submitting-tip-box">
      <div class="spin">
        <a-spin size="large"/>
      </div>
      <div class="nr" v-if="siteName === 'signet'">正在提交您的付款資料，此過程中請勿刷新和關閉頁面，如有問題請及時聯絡您的銷售代表。</div>
      <div class="nr" v-else>Please do not refresh and close the page during this process. Please contact your sales representative promptly if you have any questions.</div>
    </div>
  </a-modal>
  <!-- 客人提交失败 提示 -->
  <a-modal
    v-model="submissionTipErrorModal" 
    :class="siteName === 'signet' ? 'submission-modal-box sig-box' : 'submission-modal-box sup-box'"
    :footer="null"
    :maskClosable="false"
    :dialog-style="{ top: '200px' }"
  >
    <div slot="title">{{siteName === 'signet' ? '提交失敗' : 'Failed to submit'}}</div>
    <div class="submitting-tip-box">
      <div class="nr" v-if="siteName === 'signet'">您的付款資料提交失敗，請稍後再試。如仍有問題請聯絡您的銷售代表，我們會盡快處理。</div>
      <div class="nr" v-else>Your payment information was not submitted, please try again later.If you still have problems, please contact your sales representative and we will take care of it as soon as possible.</div>
    </div>
  </a-modal>

  <!-- 付款操作说明 -->
  <a-modal
    v-model="operatingModal" 
    :maskClosable="false"
    width="740px"
    class="operating-modal-box"
    :class="siteName === 'signet' ? 'operating-modal-box' : 'operating-modal-box sup-box'"
  >
    <div slot="title">{{siteName === 'signet' ? '付款操作說明' : 'Payment Instructions'}}</div>
    <ul>
      <li>
        <div class="title">
          <span :class="siteName === 'signet' ? '' : 'sup-li'">{{siteName === 'signet' ? '1、' : '1.'}}</span>
          <span>{{siteName === 'signet' ? '超值旅遊接受支票和信用卡進行線上付款，您可點選支付的方式：' : 'We support payment by check or credit card. Please choose your preferred method:'}}</span>
        </div>
        <div class="img">
          <img v-if="siteName === 'signet'" src="https://www.signettours.com/web-public/img/payment_operation_1.png" style="width: 380px;">
          <img v-else src="https://www.superatours.com/web-public/img/payment_operation_1.png" style="width: 380px;">
        </div>
        <div class="nr">{{siteName === 'signet' ? '我們在收到款項後會即時更新訂單，並以電子郵件通知您。' : 'After receiving your payment, we will update your reservations and notify you by email.'}}</div>
      </li>
      <li>
        <div class="title">
          <span :class="siteName === 'signet' ? '' : 'sup-li'">{{siteName === 'signet' ? '2、' : '2.'}}</span>
          <span>{{siteName === 'signet' ? '如您用支票方式全額支付基礎團費(不含額外費用)可享受2%的現金折扣。您需上傳付款支票的圖片，或是以郵寄的方式將支票寄到超值旅遊公司地址：' : 'You may enjoy a 2% discount off your tour fare if you pay for your tour in full by check (deposit and balance). To pay by check, please upload a photo of your check or send by mail to our addresses below:'}}</span>
        </div>
        <div class="img">
          <img v-if="siteName === 'signet'" src="https://www.signettours.com/web-public/img/payment_operation_6.png" style="width: 500px;">
          <img v-else src="https://www.superatours.com/web-public/img/payment_operation_6.png" style="width: 500px;">
        </div>
        <div :style="siteName === 'signet' ? 'color: red;font-size: 14px;padding-left:25px;' : 'color: red;font-size: 14px;padding-left:17px;'">
          <div class="title">
            <span style="padding-right: 2px;">*</span>
            <span>
              <strong v-if="siteName === 'supera'" style="font-weight: 500;">Land fare:</strong>
              {{siteName === 'signet' ? '基礎團費：包含行程所述內容中的所有房費、餐食、門票以及由超值旅遊負責預訂機票的接機費用。' : ' includes hotels, meals, admissions as noted on our itinerary and complimentary transfers when applicable.'}}
            </span>
          </div>
          <div class="title">
            <span style="padding-right: 2px;">*</span>
            <span>
              <strong v-if="siteName === 'supera'" style="font-weight: 500;">Additional costs:</strong>
              {{siteName === 'signet' ? '額外費用：包含酒店延泊、自費的推薦項目、自費安排的接送機、保險項目、簽證費，以及根據您特別要求所增加的費用。' : ' hotel extensions, recommended items at your own expense, private or early/late transfers, travel insurance, visas, and other additional expenses that may be applicable for your reservations.'}}
            </span>
          </div>
        </div>
      </li>
      <li>
        <div class="title">
          <span :class="siteName === 'signet' ? '' : 'sup-li'">{{siteName === 'signet' ? '3、' : '3.'}}</span>
          <span>{{siteName === 'signet' ? '請注意，如使用信用卡支付任何部分團費（訂金或餘額），2% 的折扣將不適用；' : 'Please note the 2% discount will not apply if any part (deposit or balance) of the land tour payment is paid by credit card.'}}</span>
        </div>
        <div class="img">
          <div v-if="paymentData && paymentData.paymentAmountType === '3'">
            <img v-if="siteName === 'signet'" src="https://www.signettours.com/web-public/img/payment_operation_2.png" style="width: 420px;">
            <img v-else src="https://www.superatours.com/web-public/img/payment_operation_2.png" style="width: 420px;">
          </div>
          <div v-else>
            <img v-if="siteName === 'signet'" src="https://www.signettours.com/web-public/img/payment_operation_2_type.png" style="width: 420px;">
            <img v-else src="https://www.superatours.com/web-public/img/payment_operation_2_type.png" style="width: 420px;">
          </div>
        </div>
        <div class="nr">{{siteName === 'signet' ? '使用信用卡線上付款需填寫您的卡號、信用卡有效期和姓名：' : 'For credit card payments, please fill out the required information.'}}</div>
         <div class="img">
          <img v-if="siteName === 'signet'" src="https://www.signettours.com/web-public/img/payment_operation_4.png" style="width: 495px;">
          <img v-else src="https://www.superatours.com/web-public/img/payment_operation_4.png" style="width: 495px;">
        </div>
        <div class="nr">{{siteName === 'signet' ? '請在填寫以上信息後仔細閱讀我們關於信用卡付款的相關條款，並勾選確認後方可提交支付：' : 'After filling in the above information, please carefully review the important terms and conditions for credit card payments mark the checkboxes to submit the payment.'}}</div>
        <div class="img">
          <img v-if="siteName === 'signet'" src="https://www.signettours.com/web-public/img/payment_operation_5.png" style="width: 90%;">
          <img v-else src="https://www.superatours.com/web-public/img/payment_operation_5.png" style="width: 90%;">
        </div>
      </li>
      <li>
        <div class="title">
          <span :class="siteName === 'signet' ? '' : 'sup-li'">{{siteName === 'signet' ? '4、' : '4.'}}</span>
          <span>{{siteName === 'signet' ? '如您和朋友一起報名，超值旅遊支持每組客人分別支付各自團費，也可選擇和訂單中所有客人一起支付，請您在付款前和家人或朋友確認要使用哪種支付方式：' : 'If you are reserving with friends or a large party, you may choose to pay together or pay separately. Please confirm with your family or friends which payment method you like to use before paying:'}}</span>
        </div>
        <div class="img">
          <img v-if="siteName === 'signet'" src="https://www.signettours.com/web-public/img/payment_operation_3.png" style="width: 340px;">
          <img v-else src="https://www.superatours.com/web-public/img/payment_operation_3.png" style="width: 340px;">
        </div>
      </li>
      <li>
        <div class="title">
          <span :class="siteName === 'signet' ? '' : 'sup-li'">{{siteName === 'signet' ? '5、' : '5.'}}</span>
          <span>{{siteName === 'signet' ? '如您之前在超值旅遊留有餘款，可用於抵扣團費餘款，但不可用於支付訂金。' : 'If you have a previous travel credit with us, it will be deducted from your final tour balance. You will still be required to submit your deposit to secure your space.'}}</span>
        </div>
      </li>
    </ul>
    <div :style="siteName === 'signet' ? 'padding: 10px 0px 15px;text-align: center;font-size: 18px;color: #eb6e23;' : 'padding: 10px 0px 15px;text-align: center;font-size: 18px;color: #143293;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;font-weight: 500;'">
      {{siteName === 'signet' ? '如您有任何疑問，歡迎隨時聯絡，謝謝！' : 'Please feel free to contact us if you have any questions, thank you!'}}
    </div>
    <div slot="footer">
      <a-button @click="closeOperating">Close</a-button>
    </div>
  </a-modal>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

const $ = window.$

// console.log('top', document.referrer)

const cdbApiBaseURL = (process.env.VUE_APP_API_SERVER_BASE_URL || '') + '/'

// let apiserverUrl = null

let vm = null

const PaymentApi = {
  // API
  query: function query(paymentId, websiteType, type) {
    return axios({
      url: cdbApiBaseURL + 'api/open/newobs/payment/' + paymentId + '?websiteType=' + websiteType + '&type=' + type,
      timeout: 1000 * 60 * 3, // 请求超时时间
      method: 'get'
    })
  },
  // 通过邮寄送方式提交 API
  payByMail: function payByMail(paymentId, param) {
    return axios({
      url: cdbApiBaseURL + 'api/open/newobs/payment/' + paymentId + '/payByMail',
      timeout: 1000 * 60 * 3, // 请求超时时间
      method: 'post',
      data: param
    })
  },
  // 通过电话送方式提交 API
  payByPhone: function payByPhone(paymentId, param) {
    return axios({
      url: cdbApiBaseURL + 'api/open/newobs/payment/' + paymentId + '/payByPhone',
      timeout: 1000 * 60 * 3, // 请求超时时间
      method: 'post',
      data: param
    })
  },
  // 通过上传照片方式提交 API
  payByCheck: function payByCheck(paymentId, formData) {
    return axios({
      url: cdbApiBaseURL + 'api/open/newobs/payment/' + paymentId + '/payByCheck',
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 1000 * 60 * 3, // 请求超时时间
      method: 'post',
      data: formData
    })
  },
  // 通过信用卡方式提交 API
  payByCreditCard: function payByCreditCard(paymentId, formData) {
    return axios({
      url: cdbApiBaseURL + 'api/open/newobs/payment/' + paymentId + '/payByCreditCard',
      timeout: 1000 * 60 * 3, // 请求超时时间
      method: 'post',
      data: formData
    })
  }
}

function myValidateCreditCard(result) {
  if (this.val().length > 2) {
    if (this.val() != '') {
      vm.cridetCardValid = result.valid
      if (result.card_type != null) {
        vm.cridetCardCategory = result.card_type.name
      }
      if (result.card_type == null) {
        this.log = 'This credit card is not valid'
      } else if (result.card_type.name == 'amex' || result.card_type.name == 'visa' || result.card_type.name == 'mastercard') {
        this.log = ''
      } else {
        this.log = 'This credit card is not valid'
      }
    } else {
      this.log = ''
    }
  } else {
    this.log = ''
  }
}

// 获取支票图片上传默认值
function getDefaultCheckPictureFiles () {
  return { uploadErr: false, uploadErrType: false, uploadFileObject: null}
}

export default {
  name: 'PaymentAuthorization',
  data: function() {
    return {
      // 订单号
      paymentId: null,
      websiteType: 'USA',
      siteName: 'signet',
      submitPrice: null,
      resultData: null,
      // form 表单
      formCreditCard: this.$form.createForm(this, { name: 'coordinated' }),
      // 付款方式 1 信用卡 2 支票
      paymentMethod: 1,
      // 支票付款方式 1 拍照上传 2 邮寄
      checkPaymentMethod: 1,
      expDate: '',
      phone: '',
      cardNumber: '',
      pindex: 0,
      maxLengthsCardNumber: 18,
      imageUrl: '',
      loading: false,
      // 正在提交
      submissionTipModal: false,
      submissionTipErrorModal: false,
      submitting: false,
      paymentTypeLoading: false,
      paymentData: null,
      noPayCusts: [],
      noPayCustomerList: [],
      selectedCustomers: [],
      submittedSuccessfully: false,
      continueLoading: false,
      checked: false,
      checkedCard: false,
      firstChecked: true,
      firstCheckedCard: true,
      errPaymentName: false,
      paymentFor: 0,
      paymentAll: [],
      // 支付金额
      amount: null,
      // 信用卡卡种
      cridetCardCategory: null,
      // 信用卡校验是否有效
      cridetCardValid: null,
      // 是否已经提示过信用卡2%折扣
      isCreditCardNotice: false,
      isCheckNotice: false,
      // 是否已经提示过信用卡2%折扣弹出层
      creditCardModal: false,
      // Check 2% 折扣弹出层
      checkModal: false,
      checkDiscount: null,
      // 上传文件列表
      checkPictureFiles: null,
      guestLengthTips: false,
      guestLength: null,
      successFullyPayId: null,
      // 付款类型
      paymentType: true,
      paymentTypeNumber: false,
      // paymentRecord: false,
      paymentTypeRespectively: false,
      errBalanceSeparateAmount: false,
      discountPrice: null,
      amountManual: null,
      amountNumberTimes: null,
      discountAmountNumberTimes: null,
      selectedCustomersAll: false,
      numberLengthAll: null,
      selectedCustomersList: false,
      selectedCustomersAllId: [],
      selectedCustomersLgth: [],
      allAmountShow: true,
      formOfPaymentcc: false,
      paymentFormType: null,
      log: '',
      // 付款操作说明
      operatingModal: false,
      cardDateBox: true,
      expDateErr: '',
      datas: [],
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: 'Name',
          scopedSlots: { customRender: 'custs' }
        },
        {
          title: 'Submitted Date/Time(PST)',
          customRender: (value, record) => this.dateTimeFormatB(record.createTime)
        },
        {
          title: 'Amount Paid',
          scopedSlots: { customRender: 'totalPrice' },
          align: 'right'
        }
      ],
      ifSendEmail: null,
      checkError: false,
      showInsurance: false
    }
  },
  computed: {},
  beforeCreate() {
    document.querySelector('html').setAttribute('style', 'overflow: hidden;')
    document.querySelector('body').setAttribute('style', 'overflow: hidden;')
  },
  mounted() {
    vm = this
    this.loadData()
  },
  watch: {},
  methods: {
    async loadData() {
      this.loading = true
      // apiserverUrl = this.$route.query.apiserverUrl
      this.paymentId = this.$route.params.paymentId
      this.successFullyPayId = this.$route.query.pay
      let websiteType = this.$route.query.websiteType
      if (!websiteType) {
        websiteType = 'USA'
      }
      this.websiteType = websiteType
      let siteName = this.$route.query.siteName
      let type = this.$route.query.type
      if (typeof(type) == 'undefined') {
        type = ''
      }
      if (!siteName) {
        siteName = 'signet'
      }
      this.siteName = siteName
      const res = await PaymentApi.query(this.paymentId,this.websiteType, type)
      const result = res.data
      if (result.success === false) {
        if (result.errorCode === '0') {
          // 去404
          try {
            this.$nextTick(() => {
              parent.postMessage('404', '*')
            })
          } catch (e) {
            console.log(e)
          }
        } else {
          console.log(result.errorCode, result.errorMessage)
        }
      } else {
        const customers = result.data.customers
        let groups = {}
        if (customers && customers.length > 0) {
          customers.forEach(cust => {
            groups[cust.airGroupId] = groups[cust.airGroupId] || []
            groups[cust.airGroupId].push(cust)
          })
          groups = Object.keys(groups).map(function (group) {
              return groups[group]
          })
        }
        result.data.customers = groups
        // Amount = 0 的时候去404
        // if(result.data.amount == 0){
        //   // 去404
        //   try {
        //     this.$nextTick(() => {
        //       parent.postMessage('404', '*')
        //     })
        //   } catch (e) {
        //     console.log(e)
        //   }
        // }

        this.resultData = result.data
        // Full Payment 没有付全 则显示 Balance
        if((result.data.paymentAmountType === '2' || result.data.paymentAmountType === '3') && result.data.payHistorys && result.data.payHistorys.length > 0){
          result.data.payHistorys.forEach(item => {
            console.log('item', item.paymentType)
            if(item.paymentType === 'B' || item.paymentType === 'D'){
              result.data.paymentAmountType = '2'
            }
          })
        }
        
        // 判断是否是CC付款方式
        // const paymentFormType = []
        // if(result.data && (result.data.payHistorys || result.data.payHistorys.length > 0)){
        //   result.data.payHistorys.forEach(e=>{
        //     paymentFormType.push(e.formOfPayment)
        //   })
        //   if(paymentFormType.indexOf('CC') > -1){
        //     this.formOfPaymentcc = true
        //   } else {
        //     this.formOfPaymentcc = false
        //   }
        // }
        this.paymentFormType = (result.data.payHistorys && result.data.payHistorys.length > 0) ? result.data.payHistorys[result.data.payHistorys.length -1] : null
        if(this.paymentFormType && this.paymentFormType.formOfPayment.indexOf('CC') > -1){
          this.formOfPaymentcc = true
        } else {
          this.formOfPaymentcc = false
        }

        if (result.data.customerList === null || result.data.customerList.length === 0 || this.successFullyPayId === '0' || result.data.amount <= '0' || result.data.discountAmount <= '0') {
          // 已经提交过了，显示已提交提示文字
          this.submittedSuccessfully = true
          this.paymentData = result.data
          this.noticeParentUnloading()
        } else {
          // const customerList = result.data.customerList
          // let selectedCustomers = []
          // if (customerList && customerList.length > 0) {
          //   selectedCustomers = customerList.map(item => {
          //     return item.bkcId
          //   })
          // }
          // this.selectedCustomers = selectedCustomers
          
          this.paymentData = result.data
          this.noPayCustomerList = result.data.customerList
          this.numberLengthAll = result.data.customerList.length
          console.log('this.noPayCustomerList', this.numberLengthAll)

          this.datas = this.paymentData.payHistorys

          // 余款 人数的平均价格
          const amountNumberTimes = Math.ceil(this.paymentData.amount / this.paymentData.customerList.length)
          const discountAmountNumberTimes = Math.ceil(this.paymentData.discountAmount / this.paymentData.customerList.length)
          this.amountNumberTimes = amountNumberTimes
          this.discountAmountNumberTimes = discountAmountNumberTimes

          // checkDiscount 是true 就默认为Check
          if(this.paymentData.checkDiscount){
            this.paymentMethod = 2
          }else{
            this.paymentMethod = this.paymentData.selectPaymentMethod == 'CC' ? 1 : 2
          }
          if (this.paymentMethod === 1) {
            if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3'){
              if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                this.amountManual = this.amountNumberTimes * this.paymentFor
              } else if(this.paymentFor == 0) {
                this.amountManual = null
              } else {
                this.amount = this.paymentData.amount
              }
            } else if(this.paymentData.paymentAmountType === '4'){
              if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                this.amount = this.amountNumberTimes * this.paymentFor
              } else if(this.paymentFor == 0) {
                this.amount = this.amountNumberTimes * this.paymentFor
              } else {
                this.amount = this.paymentData.amount
              }
              
            } else{
              this.amount = this.paymentData.amount * this.paymentFor
            }
            this.discountPrice = this.paymentData.amount

            if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
              if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
                this.amount = this.paymentData.amount
              } else {
                this.amount = this.paymentData.amount * this.paymentData.customerList.length
                // if(this.paymentData.paymentAmountType === '1') {
                //   this.amount = this.paymentData.realAllDepositAmount
                // }
              }
            }

          } else {
            // checkDiscount 是true 价格没有折扣
            if(this.paymentData.checkDiscount){
              if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3'){
                if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                  this.amountManual = this.amountNumberTimes * this.paymentFor
                } else if(this.paymentFor == 0) {
                  this.amountManual = null
                } else {
                  this.amount = this.paymentData.amount
                }
              } else if(this.paymentData.paymentAmountType === '4'){
                if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                  this.amount = this.amountNumberTimes * this.paymentFor
                } else if(this.paymentFor == 0) {
                  this.amount = this.amountNumberTimes * this.paymentFor
                } else {
                  this.amount = this.paymentData.amount
                }
                
              } else {
                this.amount = this.paymentData.amount * this.paymentFor
              }
              this.discountPrice = this.paymentData.amount

              if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
                if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
                  this.amount = this.paymentData.amount
                } else {
                  this.amount = this.paymentData.amount * this.paymentData.customerList.length
                  // if(this.paymentData.paymentAmountType === '1') {
                  //   this.amount = this.paymentData.realAllDepositAmount
                  // }
                }
              }
            } else {
              if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
                if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                  this.amountManual = this.discountAmountNumberTimes * this.paymentFor
                } else if(this.paymentFor == 0) {
                  this.amountManual = null
                } else {
                  this.amount = this.paymentData.discountAmount
                }
              } else if(this.paymentData.paymentAmountType === '4'){
                if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                  this.amount = this.discountAmountNumberTimes * this.paymentFor
                } else if(this.paymentFor == 0) {
                  this.amount = this.discountAmountNumberTimes * this.paymentFor
                } else {
                  this.amount = this.paymentData.discountAmount
                }
                
              } else {
                this.amount = this.paymentData.discountAmount * this.paymentFor
              }
              this.discountPrice = this.paymentData.discountAmount
              if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
                if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
                  this.amount = this.paymentData.discountAmount
                } else {
                  this.amount = this.paymentData.discountAmount * this.paymentData.customerList.length
                  // if(this.paymentData.paymentAmountType === '1') {
                  //   this.amount = this.paymentData.realAllDepositAmount
                  // }
                }
              }
            }
          }

          // 初始化上传支票图片列表
          this.checkPictureFiles = [getDefaultCheckPictureFiles()]
          this.$nextTick(() => {
            if (this.paymentMethod === 1){
              $('.card-number-input').validateCreditCard(myValidateCreditCard)
            }
          })
          
          const customerList = result.data.customerList
          let selectedCustomersAllId = []
          if (customerList && customerList.length > 0) {
            selectedCustomersAllId = customerList.map(item => {
              return item.bkcId
            })
          }
          this.selectedCustomersAllId = selectedCustomersAllId

          // 默认选中
          if(this.numberLengthAll > 1){
            this.allAmountShow = false
            this.selectedCustomersAll = false
            this.selectedCustomersList = true
            this.selectedCustomers = 'All'
            this.paymentAll = ['All']
            this.paymentFor = this.selectedCustomersAllId.length
            if(this.paymentMethod === 1){
              if(this.paymentData.paymentAmountType === '1'){
                this.amount = this.paymentData.amount * this.paymentData.customerList.length
              } else {
                this.amountManual = this.paymentData.amount
                this.amount = this.paymentData.amount
              }
            } else {
              if(this.paymentData.paymentAmountType === '1'){
                this.amount = this.paymentData.discountAmount * this.paymentData.customerList.length
              } else {
                this.amountManual = this.paymentData.discountAmount
                this.amount = this.paymentData.discountAmount
              }
            }
          } else {
            this.allAmountShow = false
            const customerDatas = result.data.customerList
            let selectedCustomers = []
            if (customerDatas && customerDatas.length > 0) {
              selectedCustomers = customerDatas.map(item => {
                return item.bkcId
              })
            }
            this.selectedCustomers = selectedCustomers
            this.paymentFor = this.selectedCustomers.length
            if(this.paymentMethod === 1){
              if(this.paymentData.paymentAmountType === '1'){
                this.amount = this.paymentData.amount * this.paymentData.customerList.length
              } else {
                this.amountManual = this.paymentData.amount
                this.amount = this.paymentData.amount
              }
            } else {
              if(this.paymentData.paymentAmountType === '1'){
                this.amount = this.paymentData.discountAmount * this.paymentData.customerList.length
              } else {
                this.amountManual = this.paymentData.discountAmount
                this.amount = this.paymentData.discountAmount
              }
            }
          }
          
        }
      }
      this.loading = false
      try {
        this.$nextTick(() => {
          parent.postMessage(document.getElementById('pamentyWrapper').offsetHeight, '*')
        })
      } catch (e) {
        console.log(e)
      }
    },
    // 通知父窗口loading
    noticeParentLoading () {
      try {
        parent.postMessage('loading', '*')
      } catch (e){
        console.log(e)
      }
    },
    // 通知父窗口关闭loading
    noticeParentUnloading () {
      try {
        console.log('1111111')
        parent.postMessage('unloading', '*')
      } catch (e){
        console.log(e)
      }
    },
    handlSubmit() {
      this.submitting = true
      let paymentMethod = null
      if (this.paymentMethod === 1) {
        paymentMethod = 'byCreditCard'
      } else {
        if (this.checkPaymentMethod === 1) {
          paymentMethod = 'byCheckPictureUpload'
        } else {
          paymentMethod = 'byCheckMail'
          if(this.websiteType == 'CAN'){
            paymentMethod = 'byCheckPhone'
          }
        }
      }
      if(this.selectedCustomers == null || this.selectedCustomers.length == 0){
        this.submitting = false
        this.errPaymentName = true
        return
      }
      
      if((this.amountManual == null || this.amountManual == 0) && (this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3')){
        this.submitting = false
        this.errBalanceSeparateAmount = true
        return
      }
      if (this.websiteType == 'USA' && (this.showInsurance || this.paymentData.paymentAmountType === '1') && this.ifSendEmail == null) {
        this.submitting = false
        this.checkError = true
        return
      }

      // 如果是邮寄方式提交
      if (paymentMethod === 'byCheckMail') {
        this.submitByCheckMail()
      }
      // 如果是电话方式提交
      if (paymentMethod === 'byCheckPhone') {
        this.submitByCheckPhone()
      }
      // 通过上传照片方式提交
      if (paymentMethod === 'byCheckPictureUpload') {
        this.submitByCheckPictureUpload()
      }
      // 通过信用卡方式提交
      if (paymentMethod === 'byCreditCard') {
        this.submitByCreditCard()
      }
    },
    // continuePayment () {
    //   this.noticeParentLoading()
    //   this.$router.go(0)
    //   this.submittedSuccessfully = !this.submittedSuccessfully
    // },
    tipsModal () {
      this.noticeParentLoading()
      this.$router.go(0)
    },
    tipsCancelModal () {
      this.noticeParentLoading()
      try {
        this.$nextTick(() => {
          parent.postMessage('pay', '*')
        })
      } catch (e) {
        console.log(e)
      }
    },
    // 通过邮寄送方式提交 selectedCustomersAllId
    async submitByCheckMail() {
      // this.submitting = true
      // this.noticeParentLoading()
      this.submissionTipModal = true
      try {
        const payData = {
          paymentForBkcIds: this.paymentAll.indexOf('All') > -1  ? this.selectedCustomersAllId : this.selectedCustomers,
          amount: (this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') && this.allAmountShow ? this.amountManual : this.amount,
          paymentAmountType: this.paymentData.paymentAmountType,
          ifSendEmail: this.ifSendEmail
        }
        const res = await PaymentApi.payByMail(this.paymentData.paymentId, payData)
        const result = res.data
        if (result.success === false) {
          console.log(result.errorCode, result.errorMessage)
          if (result.errorCode === '001') { // 重复提交则刷新页面
            // this.$router.go(0)
            this.submissionTipModal = false
            this.submissionTipErrorModal = true
          }
        } else {
          if (result.data.resultCode && result.data.resultCode === '001' || (this.paymentData.paymentAmountType !== '1' && this.paymentData.discountAmount != payData.amount)) {
            // this.noticeParentUnloading()
            this.submissionTipModal = false
            this.noPayCusts = result.data.custs
            this.guestLengthTips = true
          } else {
            // 去成功页面
            this.submissionTipModal = false
            this.noticeParentLoading()
            this.$router.go(0)
            this.submittedSuccessfully = true
          }
        }
        this.submitting = false
        // if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3'){
        //   this.noticeParentLoading()
        //   try {
        //     this.$nextTick(() => {
        //       parent.postMessage('pay', '*')
        //     })
        //   } catch (e) {
        //     console.log(e)
        //   }
        // }
      } catch (e) {
        console.log(e)
        this.submitting = false
      }
    },
    // 通过电话方式提交
    async submitByCheckPhone() {
      // this.submitting = true
      // this.noticeParentLoading()
      this.submissionTipModal = true
      try {
        const payData =  {
          paymentForBkcIds: this.paymentAll.indexOf('All') > -1  ? this.selectedCustomersAllId : this.selectedCustomers,
          amount: (this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') && this.allAmountShow ? this.amountManual : this.amount,
          paymentAmountType: this.paymentData.paymentAmountType,
          ifSendEmail: this.ifSendEmail
        }
        const res = await PaymentApi.payByPhone(this.paymentData.paymentId, payData)
        const result = res.data
        if (result.success === false) {
          console.log(result.errorCode, result.errorMessage)
          if (result.errorCode === '001') { // 重复提交则刷新页面
            // this.$router.go(0)
            this.submissionTipModal = false
            this.submissionTipErrorModal = true
          }
        } else {
          if (result.data.resultCode && result.data.resultCode === '001' || (this.paymentData.paymentAmountType !== '1' && this.paymentData.discountAmount != payData.amount)) {
            // this.noticeParentUnloading()
            this.submissionTipModal = false
            this.guestLengthTips = true
            this.noPayCusts = result.data.custs
          } else {
            this.submissionTipModal = false
            // 去成功页面
            this.noticeParentLoading()
            this.$router.go(0)
            this.submittedSuccessfully = true
          }
        }
        this.submitting = false
        // if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3'){
        //   this.noticeParentLoading()
        //   try {
        //     this.$nextTick(() => {
        //       parent.postMessage('pay', '*')
        //     })
        //   } catch (e) {
        //     console.log(e)
        //   }
        // }
      } catch (e) {
        console.log(e)
        this.submitting = false
      }
    },
    // 通过上传照片方式提交
    async submitByCheckPictureUpload() {
      this.uploadErr = false
      // 校验文件是否上传
      const checkPictureFiles = this.checkPictureFiles
      let checkPictureFilesValid = true
      if (checkPictureFiles && checkPictureFiles.length > 0) {
        
        for (let i=0; i<checkPictureFiles.length; i++) {
          const cp = checkPictureFiles[i]
          if (cp.uploadFileObject === null) {
            checkPictureFilesValid = false
            if(cp.uploadErrType == true){
              cp.uploadErrType = true
            }else{
              cp.uploadErr = true
            }
          }
        }
      }
      if (!checkPictureFilesValid) {
        this.submitting = false
        return
      }
      this.submitting = true
      this.submissionTipModal = true
      // this.noticeParentLoading()
      const formData = new FormData()
      if (checkPictureFiles && checkPictureFiles.length > 0) {
        for (let i=0; i<checkPictureFiles.length; i++) {
          const cp = checkPictureFiles[i]
          if (cp.uploadFileObject != null) {
            formData.append('files', cp.uploadFileObject)
          }
        }
      }
      formData.append('amount', (this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') && this.allAmountShow ? this.amountManual : this.amount)
      formData.append('paymentAmountType', this.paymentData.paymentAmountType)
      const paymentForBkcIds = this.selectedCustomers.join(',')
      formData.append('paymentForBkcIds', this.paymentAll.indexOf('All') > -1  ? this.selectedCustomersAllId : paymentForBkcIds)
      formData.append('ifSendEmail', this.ifSendEmail)
      formData.append('siteName', this.siteName)
      try { 
        // console.log('result ------', result.data, this.amountManual)
        // return
        const res = await PaymentApi.payByCheck(this.paymentData.paymentId, formData)
        const result = res.data
        if (result.success === false) {
          console.log(result.errorCode, result.errorMessage)
          if (result.errorCode === '001') { // 重复提交则刷新页面
            // this.$router.go(0)
            this.submissionTipModal = false
            this.submissionTipErrorModal = true
          }
        } else {
          if (result.data.resultCode && result.data.resultCode === '001' || (this.paymentData.paymentAmountType !== '1' && this.paymentData.discountAmount != (this.allAmountShow ? this.amountManual : this.amount))) {
            // this.noticeParentUnloading()
            this.submissionTipModal = false
            this.guestLengthTips = true
            this.noPayCusts = result.data.custs
            this.submitting = false
          } else {
            this.submissionTipModal = false
            // 去成功页面
            this.noticeParentLoading()
            this.$router.go(0)
            this.submittedSuccessfully = true
          }
        }
        this.submitting = false
        // if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3'){
        //   this.noticeParentLoading()
        //   try {
        //     this.$nextTick(() => {
        //       parent.postMessage('pay', '*')
        //     })
        //   } catch (e) {
        //     console.log(e)
        //   }
        // }
      } catch (e) {
        console.log(e)
        this.submitting = false
      }
    },
    // 通过信用卡方式提交
    async submitByCreditCard() {
      // this.submitting = true
      const formData = this.formCreditCard.getFieldsValue()
      let allValid = true
      // 校验信用卡号是否有效
      if (this.cridetCardValid != null && this.cridetCardValid == false) {
        this.submitting = false
        $('.card-number-box .ant-input').addClass('active')
        this.log = 'This credit card is not valid'
        allValid = false
      } else if (this.log !== '') {
        this.submitting = false
        this.log = ''
      }

      // 校验不能少于本月本年
      const days = moment(formData.expDate, 'MM/YY').diff(moment(new Date(), 'MM/YY'), 'months')
      console.log('days', days)
      if ((formData.expDate != null && formData.expDate.length < 5) || (isNaN(days) || days < 0)) {
        this.submitting = false
        // $('.card-date-box .ant-input').addClass('active')
        this.cardDateBox = false
        this.expDateErr = 'Invalid date'
        allValid = false
      }

      const valid = await this.validateCreditCardForm()
      if (!valid) {
        this.submitting = false
        allValid = false
      }
      if (!this.checked) {
        this.submitting = false
        this.firstChecked = false
        allValid = false
      }
      if (!this.checkedCard) {
        this.submitting = false
        this.firstCheckedCard = false
        allValid = false
      }
      if (!allValid) {
        return false
      }
      this.submissionTipModal = true
      // this.noticeParentLoading()
      
      formData.paymentForBkcIds = this.paymentAll.indexOf('All') > -1  ? this.selectedCustomersAllId : this.selectedCustomers
      formData.amount = (this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') && this.allAmountShow ? this.amountManual : this.amount
      formData.cridetCardCategory = this.cridetCardCategory
      formData.paymentAmountType = this.paymentData.paymentAmountType
      formData.ifSendEmail = this.ifSendEmail
      try {
        const res = await PaymentApi.payByCreditCard(this.paymentData.paymentId, formData)
        const result = res.data
        if (result.success === false) {
          console.log(result.errorCode, result.errorMessage)
          if (result.errorCode === '001') { // 重复提交则刷新页面
            // this.$router.go(0)
            this.submissionTipModal = false
            this.submissionTipErrorModal = true
          }
        } else {
          if (result.data.resultCode && result.data.resultCode === '001' || (this.paymentData.paymentAmountType !== '1' && this.paymentData.amount != formData.amount)) {
            // this.noticeParentUnloading()
            this.submissionTipModal = false
            this.guestLengthTips = true
            this.noPayCusts = result.data.custs
          } else {
            this.submissionTipModal = false
            // 去成功页面
            this.noticeParentLoading()
            this.$router.go(0)
            this.submittedSuccessfully = true
          }
        }
        this.submitting = false
        // if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3'){
        //   this.noticeParentLoading()
        //   try {
        //     this.$nextTick(() => {
        //       parent.postMessage('pay', '*')
        //     })
        //   } catch (e) {
        //     console.log(e)
        //   }
        // }
      } catch (e) {
        console.log(e)
        this.submitting = false
      }
    },
    validateCreditCardForm() {
      const that = this
      var promise = new Promise(function(resolve) {
        that.formCreditCard.validateFields(err => {
          if (!err) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
      return promise
    },
    onChange(e) {
      this.checked = e.target.checked
      this.firstChecked = false
    },
    onChange1(e) {
      this.checkedCard = e.target.checked
      this.firstCheckedCard = false
    },
    paymentName(e) {
      console.log('this.selectedCustomers', this.selectedCustomers)
      if(e.indexOf('All') > -1){
        this.selectedCustomersLgth = this.selectedCustomersAllId
        console.log('this.selectedCustomersLgth', this.selectedCustomersLgth = this.selectedCustomersAllId)
      }
      this.selectedCustomersLgth = this.selectedCustomersAllId
      // 根据客人是否有保险，没有就显示保险文字hasInsuranceFlag
      // 根据客人首次付款判断是否超过21天, 超过21天就不显示保险文字ifWithin21days
      const newList = this.copyDataByJSON(this.paymentData.customers)
      newList.forEach(it => {
        if (e.indexOf('All') > -1) {
          const currentList = it.filter(item => this.selectedCustomersAllId.includes(item.bkcId))
          currentList.forEach(item => {
            if (!item.ifWithin21days) {
              item.hasInsuranceFlag = true
            }
          })
          const list = currentList.filter(item => {
            return !item.hasInsuranceFlag
          })
          if (!list || list.length == 0) {
            this.showInsurance = false
            this.getHeightChange()
          } else {
            this.showInsurance = true
            this.getHeightChange()
          }
        } else {
          const currentList = it.filter(item => e.includes(item.bkcId))
          currentList.forEach(item => {
            if (!item.ifWithin21days) {
              item.hasInsuranceFlag = true
            }
          })
          const list = currentList.filter(item => {
            return !item.hasInsuranceFlag
          })
          if (!list || list.length == 0) {
            this.showInsurance = false
            this.getHeightChange()
          } else {
            this.showInsurance = true
            this.getHeightChange()
          }
        }
      })

      if (this.paymentMethod === 1) {
        if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
          if(e.length > 0 && e.length != this.paymentData.customerList.length){
            this.amountManual = this.amountNumberTimes * e.length
          } else if(e.length == 0){
            this.amountManual = null
          } else {
            this.amount = this.paymentData.amount
          }
        } else if(this.paymentData.paymentAmountType === '4'){
          if(e.length > 0 && e.length != this.paymentData.customerList.length){
            this.amount = this.amountNumberTimes * e.length
          } else if(e.length == 0){
            this.amount = this.amountNumberTimes * e.length
          } else {
            this.amount = this.paymentData.amount
          }
          
        } else {
          this.amount = this.paymentData.amount * e.length
        }
        if(e.indexOf('All') > -1 || e.length == this.paymentData.customerList.length){
          if(e.indexOf('All') > -1){
            this.selectedCustomersAll = false
            this.selectedCustomersList = true
          } else {
            this.selectedCustomersAll = true
            this.selectedCustomersList = false
          }
          if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4'){
            this.amount = this.paymentData.amount
            this.amountManual = this.paymentData.amount
          } else {
            this.amount = this.paymentData.amount * this.paymentData.customerList.length
            // if(this.paymentData.paymentAmountType === '1') {
            //   this.amount = this.paymentData.realAllDepositAmount
            // }
          }
          this.allAmountShow = false
          this.errBalanceSeparateAmount = false
        } else if(e.length == 0){
          this.selectedCustomersAll = false
          this.selectedCustomersList = false
          this.allAmountShow = true
          this.errBalanceSeparateAmount = true
        } else {
          this.selectedCustomersAll = true
          this.selectedCustomersList = false
          this.allAmountShow = true
          this.errBalanceSeparateAmount = false
        }
      } else {
        // checkDiscount 是true 价格没有折扣
        if(this.paymentData.checkDiscount){
          if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
            if(e.length > 0 && e.length != this.paymentData.customerList.length){
              this.amountManual = this.amountNumberTimes * e.length
            } else if(e.length == 0){
              this.amountManual = null
            } else {
              this.amount = this.paymentData.amount
            }
          } else if(this.paymentData.paymentAmountType === '4'){
            if(e.length > 0 && e.length != this.paymentData.customerList.length){
              this.amount = this.amountNumberTimes * e.length
            } else if(e.length == 0){
              this.amount = this.amountNumberTimes * e.length
            } else {
              this.amount = this.paymentData.amount
            }
            
          } else {
            this.amount = this.paymentData.amount * e.length
          }
          if(e.indexOf('All') > -1 || e.length == this.paymentData.customerList.length){
            if(e.indexOf('All') > -1){
              this.selectedCustomersAll = false
              this.selectedCustomersList = true
            } else {
              this.selectedCustomersAll = true
              this.selectedCustomersList = false
            }
            if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4'){
              this.amount = this.paymentData.amount
              this.amountManual = this.paymentData.amount
            } else {
              this.amount = this.paymentData.amount * this.paymentData.customerList.length
              // if(this.paymentData.paymentAmountType === '1') {
              //   this.amount = this.paymentData.realAllDepositAmount
              // }
            }
            this.allAmountShow = false
            this.errBalanceSeparateAmount = false
          } else if(e.length == 0){
            this.selectedCustomersAll = false
            this.selectedCustomersList = false
            this.allAmountShow = true
            this.errBalanceSeparateAmount = true
          } else {
            this.selectedCustomersAll = true
            this.selectedCustomersList = false
            this.allAmountShow = true
            this.errBalanceSeparateAmount = false
          }
        } else {
          if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
            if(e.length > 0 && e.length != this.paymentData.customerList.length){
              this.amountManual = this.discountAmountNumberTimes * e.length
            } else if(e.length == 0){
              this.amountManual = null
            } else {
              this.amount = this.paymentData.discountAmount
            }
          } else if(this.paymentData.paymentAmountType === '4'){
            if(e.length > 0 && e.length != this.paymentData.customerList.length){
              this.amount = this.discountAmountNumberTimes * e.length
            } else if(e.length == 0){
              this.amount = this.discountAmountNumberTimes * e.length
            } else {
              this.amount = this.paymentData.discountAmount
            }
            
          } else {
            this.amount = this.paymentData.discountAmount * e.length
          }
          if(e.indexOf('All') > -1 || e.length == this.paymentData.customerList.length){
            if(e.indexOf('All') > -1 ){
              this.selectedCustomersAll = false
              this.selectedCustomersList = true
            } else {
              this.selectedCustomersAll = true
              this.selectedCustomersList = false
            }
            if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4'){
              this.amount = this.paymentData.discountAmount
              this.amountManual = this.paymentData.discountAmount
            } else {
              this.amount = this.paymentData.discountAmount * this.paymentData.customerList.length
              // if(this.paymentData.paymentAmountType === '1') {
              //   this.amount = this.paymentData.realAllDepositAmount
              // }
            }
            this.allAmountShow = false
            this.errBalanceSeparateAmount = false
          } else if(e.length == 0 ){
            this.selectedCustomersAll = false
            this.selectedCustomersList = false
            this.allAmountShow = true
            this.errBalanceSeparateAmount = true
          } else {
            this.selectedCustomersAll = true
            this.selectedCustomersList = false
            this.allAmountShow = true
            this.errBalanceSeparateAmount = false
          }
        }
      }
      this.paymentFor = e.length
      this.paymentAll = e
      if(e.length > 0) {
        this.errPaymentName = false
      } else {
        this.errPaymentName = true
      }

      
    },
    // 处理日期变化
    handleDateChange(e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/([^0-9|/])/, '')
        if (/^[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        if (/^[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        e.target.value = newValue
        this.cardDateBox = true
        // $('.expDateErr').html('')
        this.expDateErr = ''
      }
    },
    // 处理手机号变化
    handlePhoneChange(e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/([^0-9|-])/, '')
        if (/^[0-9]{3}$/.test(newValue)) {
          newValue = newValue + '-'
        }
        if (/^[0-9]{3}-[0-9]{3}$/.test(newValue)) {
          newValue = newValue + '-'
        }
        e.target.value = newValue
      }
    },
    // 处理银行卡号变化
    handleNumberChange(e) {
      const value = e.target.value
      if (value && value !== '') {
        const lengths = value.substring(0, 1) /* 截取第一位字符串 */
        let newValue = value.replace(/([^0-9|-])/, '')
        if (lengths != '3') {
          this.maxLengthsCardNumber = 19
          if (/^[0-9]{4}$/.test(newValue)) {
            if (!newValue.endsWith('-')) {
              newValue = newValue + '-'
            }
          }
          if (/^[0-9]{4}-[0-9]{4}$/.test(newValue)) {
            if (!newValue.endsWith('-')) {
              newValue = newValue + '-'
            }
          }
          if (/^[0-9]{4}-[0-9]{4}-[0-9]{4}$/.test(newValue)) {
            if (!newValue.endsWith('-')) {
              newValue = newValue + '-'
            }
          }
        } else {
          this.maxLengthsCardNumber = 18
          if (/^[0-9]{4}$/.test(newValue)) {
            newValue = newValue + '-'
          }
          if (/^[0-9]{4}-[0-9]{3}$/.test(newValue)) {
            newValue = newValue + '-'
          }
          if (/^[0-9]{4}-[0-9]{3}-[0-9]{3}$/.test(newValue)) {
            newValue = newValue + '-'
          }
        }
        this.log = ''
        e.target.value = newValue
      }
    },
    // 监控支付方式变化
    handleCheckPaymentMethodChange(e) {
      const value = e.target.value
      if (value === 2) {
        // if 价格不相等的时候 Credit Card 触发弹窗
        if (this.paymentData.amount !== this.paymentData.discountAmount) {
          if (!this.isCheckNotice) {
            this.checkModal = true
          }else{
            if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
              if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                this.amountManual = this.discountAmountNumberTimes * this.paymentFor
              } else if(this.paymentFor == 0){
                this.amountManual = null
              } else {
                this.amount = this.paymentData.discountAmount
              }
            } else if(this.paymentData.paymentAmountType === '4'){
              if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                this.amount = this.discountAmountNumberTimes * this.paymentFor
              } else if(this.paymentFor == 0){
                this.amount = this.discountAmountNumberTimes * this.paymentFor
              } else {
                this.amount = this.paymentData.discountAmount
              }
              
            } else {
              this.amount = this.paymentData.discountAmount * this.paymentFor
            }
            this.discountPrice = this.paymentData.discountAmount
            if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length ){
              if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
                this.amount = this.paymentData.discountAmount
              } else {
                this.amount = this.paymentData.discountAmount * this.paymentData.customerList.length
                // if(this.paymentData.paymentAmountType === '1') {
                //   this.amount = this.paymentData.realAllDepositAmount
                // }
              }
            }
          }
        } else {
          if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
            if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
              this.amountManual = this.discountAmountNumberTimes * this.paymentFor
            } else if(this.paymentFor == 0){
              this.amountManual = null
            } else {
              this.amount = this.paymentData.discountAmount
            }
          } else if(this.paymentData.paymentAmountType === '4'){
            if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
              this.amount = this.discountAmountNumberTimes * this.paymentFor
            } else if(this.paymentFor == 0){
              this.amount = this.discountAmountNumberTimes * this.paymentFor
            } else {
              this.amount = this.paymentData.discountAmount
            }
            
          } else {
            this.amount = this.paymentData.discountAmount * this.paymentFor
          }
          this.discountPrice = this.paymentData.discountAmount
          if(this.websiteType == 'CAN'){
            this.checkPaymentMethod = 2
          }
          if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
            if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
              this.amount = this.paymentData.discountAmount
            } else {
              this.amount = this.paymentData.discountAmount * this.paymentData.customerList.length
              // if(this.paymentData.paymentAmountType === '1') {
              //   this.amount = this.paymentData.realAllDepositAmount
              // }
            }
          }
        }
      } else {
        // if 价格不相等的时候 Check 触发弹窗
        if (this.paymentData.amount !== this.paymentData.discountAmount) {
          if (!this.isCreditCardNotice) {
            this.creditCardModal = true
          }else{
            if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
              if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                this.amountManual = this.amountNumberTimes * this.paymentFor
              } else if(this.paymentFor == 0) {
                this.amountManual = null
              } else {
                this.amount = this.paymentData.amount
              }
            } else if(this.paymentData.paymentAmountType === '4'){
              if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
                this.amount = this.amountNumberTimes * this.paymentFor
              } else if(this.paymentFor == 0) {
                this.amount = this.amountNumberTimes * this.paymentFor
              } else {
                this.amount = this.paymentData.amount
              }
            } else {
              this.amount = this.paymentData.amount * this.paymentFor
            }
            this.discountPrice = this.paymentData.amount
            if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
              if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
                this.amount = this.paymentData.amount
              } else {
                this.amount = this.paymentData.amount * this.paymentData.customerList.length
                // if(this.paymentData.paymentAmountType === '1') {
                //   this.amount = this.paymentData.realAllDepositAmount
                // }
              }
            }
          }
        } else {
          if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
            if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
              this.amountManual = this.amountNumberTimes * this.paymentFor
            } else if(this.paymentFor == 0) {
              this.amountManual = null
            } else {
              this.amount = this.paymentData.amount
            }
          } else if(this.paymentData.paymentAmountType === '4'){
            if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
              this.amount = this.amountNumberTimes * this.paymentFor
            } else if(this.paymentFor == 0) {
              this.amount = this.amountNumberTimes * this.paymentFor
            } else {
              this.amount = this.paymentData.amount
            }
            
          } else {
            this.amount = this.paymentData.amount * this.paymentFor
          }
          this.discountPrice = this.paymentData.amount
          if(this.websiteType == 'CAN'){
            this.checkPaymentMethod = 1
          }
          if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
            if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
              this.amount = this.paymentData.amount
            } else {
              this.amount = this.paymentData.amount * this.paymentData.customerList.length
              // if(this.paymentData.paymentAmountType === '1') {
              //   this.amount = this.paymentData.realAllDepositAmount
              // }
            }
          }
        }

      }
    },
    // Credit Card
    hideModal () {
      if(this.websiteType == 'CAN'){
        this.checkPaymentMethod = 1
      }
      if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
        if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
          this.amountManual = this.amountNumberTimes * this.paymentFor
        } else if(this.paymentFor == 0){
          this.amountManual = null
        } else {
          this.amount = this.paymentData.amount
        }
      } else if(this.paymentData.paymentAmountType === '4'){
        if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
          this.amount = this.amountNumberTimes * this.paymentFor
        } else if(this.paymentFor == 0){
          this.amount = this.amountNumberTimes * this.paymentFor
        } else {
          this.amount = this.paymentData.amount
        }
        
      } else {
        this.amount = this.paymentData.amount * this.paymentFor
      }
      this.discountPrice = this.paymentData.amount
      this.creditCardModal = false
      this.isCreditCardNotice = true
      if (this.paymentMethod == 1) {
        this.$nextTick(() => {
          $('.card-number-input').validateCreditCard(myValidateCreditCard)
        })
      }
      if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
        if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
          this.amount = this.paymentData.amount
        } else {
          this.amount = this.paymentData.amount * this.paymentData.customerList.length
          // if(this.paymentData.paymentAmountType === '1') {
          //   this.amount = this.paymentData.realAllDepositAmount
          // }
        }
      }
    },
    cancelModal () {
      if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
        if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
          this.amountManual = this.discountAmountNumberTimes * this.paymentFor
        } else if(this.paymentFor == 0){
          this.amountManual = null
        } else {
          this.amount = this.paymentData.discountAmount
        }
      } else if(this.paymentData.paymentAmountType === '4'){
        if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
          this.amount = this.discountAmountNumberTimes * this.paymentFor
        } else if(this.paymentFor == 0){
          this.amount = this.discountAmountNumberTimes * this.paymentFor
        } else {
          this.amount = this.paymentData.discountAmount
        }
      } else {
        this.amount = this.paymentData.discountAmount * this.paymentFor
      }
      this.discountPrice = this.paymentData.discountAmount
      this.creditCardModal = false
      this.paymentMethod = 2
      if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
        if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
          this.amount = this.paymentData.discountAmount
        } else {
          this.amount = this.paymentData.discountAmount * this.paymentData.customerList.length
          // if(this.paymentData.paymentAmountType === '1') {
          //   this.amount = this.paymentData.realAllDepositAmount
          // }
        }
      }
    },
    // Check
    checkHideModal () {
      if(this.websiteType == 'CAN'){
        this.checkPaymentMethod = 2
      }
      if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
        if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
          this.amountManual = this.discountAmountNumberTimes * this.paymentFor
        } else if(this.paymentFor == 0){
          this.amountManual = null
        } else {
          this.amount = this.paymentData.discountAmount
        }
      } else if(this.paymentData.paymentAmountType === '4'){
        if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
          this.amount = this.discountAmountNumberTimes * this.paymentFor
        } else if(this.paymentFor == 0){
          this.amount = this.discountAmountNumberTimes * this.paymentFor
        } else {
          this.amount = this.paymentData.discountAmount
        }
        
      } else {
        this.amount = this.paymentData.discountAmount * this.paymentFor
      }
      this.discountPrice = this.paymentData.discountAmount
      this.checkModal = false
      this.isCheckNotice = true
      if (this.paymentMethod == 1) {
        this.$nextTick(() => {
          $('.card-number-input').validateCreditCard(myValidateCreditCard)
        })
      }
      if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
        if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
          this.amount = this.paymentData.discountAmount
        } else {
          this.amount = this.paymentData.discountAmount * this.paymentData.customerList.length
          // if(this.paymentData.paymentAmountType === '1') {
          //   this.amount = this.paymentData.realAllDepositAmount
          // }
        }
      }
    },
    checkcancelModal () {
      if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3') {
        if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
          this.amountManual = this.amountNumberTimes * this.paymentFor
        } else if(this.paymentFor == 0){
          this.amountManual = null
        } else {
          this.amount = this.paymentData.amount
        }
      } else if(this.paymentData.paymentAmountType === '4'){
        if(this.paymentFor > 0 && this.paymentFor != this.paymentData.customerList.length){
          this.amount = this.amountNumberTimes * this.paymentFor
        } else if(this.paymentFor == 0){
          this.amount = this.amountNumberTimes * this.paymentFor
        } else {
          this.amount = this.paymentData.amount
        }
        
      } else {
        this.amount = this.paymentData.amount * this.paymentFor
      }
      this.discountPrice = this.paymentData.amount
      this.checkModal = false
      this.paymentMethod = 1
      if(this.paymentAll.indexOf('All') > -1 || this.paymentFor == this.paymentData.customerList.length){
        if(this.paymentData.paymentAmountType === '2' || this.paymentData.paymentAmountType === '3' || this.paymentData.paymentAmountType === '4') {
          this.amount = this.paymentData.amount
        } else {
          this.amount = this.paymentData.amount * this.paymentData.customerList.length
          // if(this.paymentData.paymentAmountType === '1') {
          //   this.amount = this.paymentData.realAllDepositAmount
          // }
        }
      }
    },
    handleUploadBtnClick(cpIndex) {
      const elId = 'uploadInput' + cpIndex
      const el = document.getElementById(elId)
      el.removeAttribute('capture')
      el.click()
    },
    handleTakePictureBtnClick(cpIndex) {
      const elId = 'uploadInput' + cpIndex
      const el = document.getElementById(elId)
      el.setAttribute('capture', 'camera')
      el.click()
    },
    handleUploadFileChange(cpIndex, e) {
      const files = e.target.files[0]
      const suffixName = files.name.substring(files.name.lastIndexOf('.') + 1)
      const cp = this.checkPictureFiles[cpIndex]
      if(suffixName !== 'jpg' && suffixName !== 'png'){
        cp.uploadErrType = true
        cp.uploadFileObject = null
        if(cp.uploadErrType == true){
          cp.uploadErr = false
        }
      } else {
        cp.uploadErrType = false
        cp.uploadErr = false
        cp.uploadFileObject = files
      }
      this.$set(this.checkPictureFiles, cpIndex, cp)
    },
    // 添加上传支票图片
    addCheckPictureFile () {
      this.checkPictureFiles.push(getDefaultCheckPictureFiles())
    },
    // 删除上传支票文件
    removeCheckPictureFile (cpIndex) {
      this.checkPictureFiles = this.checkPictureFiles.filter((item, index) => cpIndex != index)
    },
    // 选择支付类型 （全部付款 或 分开付款）
    separateType () {
      this.paymentTypeLoading = true
      this.noticeParentLoading()
      try {
        this.$nextTick(() => {
          parent.postMessage('sepType', '*')
        })
      } catch (e) {
        console.log(e)
      }
    },
    wholeType () {
      this.paymentTypeLoading = true
      this.noticeParentLoading()
      try {
        this.$nextTick(() => {
          parent.postMessage('whoType', '*')
        })
      } catch (e) {
        console.log(e)
      }
    },
    amountManualChange (e) {
      console.log('----', e)
      if(this.amountManual == null){
        this.errBalanceSeparateAmount = true
      }else {
        this.errBalanceSeparateAmount = false
      }
    },
    operatingInstructions () {
      this.operatingModal = true
    },
    closeOperating () {
      this.operatingModal = false
    },
    handleRadioChange (e) {
      this.checkError = false
      this.ifSendEmail = e.target.value
    },
    // 计算高度
    getHeightChange () {
      try {
        this.$nextTick(() => {
          parent.postMessage(document.getElementById('pamentyWrapper').offsetHeight, '*')
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.radio-check-box {
  color: #000;
  font-size: 16px;
  border-top: 1px #959494 dashed;
  padding: 15px 0;
  ::v-deep .ant-radio-wrapper {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 16px;
    height: 30px;
  }
}
.pamenty-box {
  color: #000;
  font-family: 'Nunito', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial,
    'Noto Sans', '微軟正黑體', '微軟雅黑體', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
}
.guest-name-item span:after{
  display: inline-block;
}
.guest-name-item.tw span:after{
  content: ' / ';
  padding: 0 5px;
}
.guest-name-item.en span:after{
  content: ' / ';
  padding: 0 5px;
}
.guest-name-item span:nth-last-of-type(1):after{
  content: none;
}
::v-deep .ant-modal-mask{
  display: none;
}
::v-deep .ant-modal-content{
  box-shadow: 0 2px 14px rgb(0 0 0 / 40%);
}
::v-deep .ant-modal .ant-modal-body{
  font-size: 1rem;
  color: #000;
}
::v-deep .ant-modal .ant-modal-header .ant-modal-title{
  font-size: 1.2rem;
}
::v-deep .ant-btn:hover, ::v-deep .ant-btn:focus{
  color: #1890ff;
  border-color: #1890ff;
}
::v-deep .ant-modal .ant-btn-primary{
  background-color: #1890ff;
  border-color: #1890ff;
  color: #fff;
}
::v-deep .ant-modal .ant-btn-primary:hover, ::v-deep .ant-modal  .ant-btn-primary:focus{
  background-color: #1580e2;
  border-color: #1580e2;
  color: #fff;
}
.pamenty-body .form-box{
  min-height: 480px;
}
.pamenty-body ::v-deep .ant-radio-checked .ant-radio-inner {
  border-color: #1890ff;
}
.pamenty-body ::v-deep .ant-radio-inner:after {
  background-color: #1890ff;
}
.pamenty-body ::v-deep .justify-content-center {
  -ms-flex-pack: center !important;
  justify-content: center !important;
}
.pamenty-body ::v-deep .ant-checkbox-checked .ant-checkbox-inner{
  background-color: #1890ff;
  border-color: #1890ff;
}
.pamenty-body ::v-deep .ant-checkbox-input:focus+.ant-checkbox-inner,
.pamenty-body ::v-deep .ant-checkbox-wrapper:hover .ant-checkbox-inner,
 .pamenty-body ::v-deep .ant-checkbox:hover .ant-checkbox-inner{
  border: 1px solid #1890ff;
}
.pamenty-body ::v-deep .ant-checkbox:hover::after,
.pamenty-body ::v-deep .ant-checkbox-wrapper:hover .ant-checkbox::after{
  border-color: #1890ff;
}
.main-tonal-bj {
  background: #143293;
  color: #fff;
}
.tw-box .main-tonal-bj {
  background: #eb6e23;
  color: #fff;
}
.ant-input {
  border-radius: 0 !important;
  height: 44px !important;
}
.ant-input:focus {
  box-shadow: none !important;
  border-color: #ced4da !important;
}
h2,
h3 {
  font-weight: bold;
}
.d-flex {
  display: -ms-flexbox !important;
  display: flex !important;
}
.tips-color {
  color: red !important;
}
.caption-box h1 {
  color: #fff;
}
.ant-form-item label {
  font-weight: bold;
  font-size: 15px;
}
.ant-checkbox-inner {
  position: absolute;
}
.ant-checkbox {
  height: 16px;
  width: 16px;
}
.credit-text{
  color: #143293;
}
.credit-title {
  font-size: 35px;
  text-align: center;
}
.authorization-box {
  padding: 40px 20px;
  min-height: 380px;
}
.btn-box {
  width: 200px;
  padding: 0;
  margin: 0;
}
.btn-box button {
  display: block;
  width: 100%;
  background: none;
  border: 0;
  box-shadow: none;
  font-size: 16px;
  height: auto;
  padding: 10px 20px;
  color: #fff;
}
.btn-box button:hover,
.btn-box button:focus {
  background: none;
  border: 0;
  color: #fff;
}
.must-read {
  color: #000;
  font-size: 15px;
  border-top: 1px #959494 dashed;
  padding-top: 20px;
  margin-bottom: 30px;
}
.must-read label {
  color: #000;
  font-size: 15px;
}
.booking-box {
  padding-top: 10px;
  font-size: 1.15rem;
  border-bottom: 1px #959494 dashed;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.booking-box > div {
  padding-bottom: 8px;
}
.booking-box strong {
  margin-right: 5px;
}
.ant-select-selection {
  border-radius: 0 !important;
  min-height: 44px;
}
.ant-select-selection__rendered {
  line-height: 44px;
}
.input-height {
  display: inline-block;
  height: 44px;
  line-height: 44px;
  color: #000;
  font-size: 15px;
}
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li,
.ant-select-selection--multiple > ul > li {
  height: 30px;
  margin-top: 7px;
  line-height: 30px;
}
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li input,
.ant-select-selection--multiple > ul > li input {
  margin-top: -6px;
}
.ant-tooltip-inner {
  background-color: #fff !important;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%) !important;
  color: #000;
}
.ant-tooltip-arrow:before {
  background-color: #fff;
  box-shadow: -1px 1px 4px #6a6a6a4d !important;
}
.card-number-box {
  position: relative;
  height: 95px;
}
.card-number-box .ant-form-item {
  height: 63px;
  margin: 0;
}
.card-number-box .log-row {
  position: absolute;
  left: 0;
  width: 100%;
  top: 43px;
  color: red;
  font-size: 14px;
}
.card-number-box .ant-input.active,
.card-date-box .ant-input.active {
  border-color: red !important;
}
.amount-box .bullet {
  position: absolute;
  left: 10px;
  line-height: 44px;
}
.amount-box .err{
  font-size: 14px;
  color: red;
}
.amount-box .ant-select-selection--single .ant-select-selection__rendered {
  margin-left: 24px;
}
.ant-form {
  color: #000;
  font-size: 1rem;
}
.upload-box {
  display: inline-block;
  position: relative;
}
.upload-box .item{
  padding-bottom: 3px;
}
.upload-box .item .upload-name{
  padding: 2px 0;
}
.upload-box .item:nth-last-of-type(1){
  padding-bottom: 0;
}
.upload-box .item:nth-last-of-type(1) .upload-name{
  padding: 0;
}
.upload-box .item .upload-icon{
  padding-left:5px;
}
.upload-box > span {
  color: #007bff !important;
}
.upload-box .err {
  color: red !important;
}
.upload-box button {
  margin-right: 5px;
}
.upload-box .ant-upload-list {
  display: -webkit-inline-box;
  vertical-align: middle;
}
.upload-box .ant-upload-list .ant-upload-list-item {
  margin-top: 0;
}
.upload-box .ant-upload-list .ant-upload-list-item:hover .ant-upload-list-item-info {
  background: none;
}
.upload-box .ant-upload-list .ant-upload-list-item-card-actions {
  opacity: 1;
}
.upload-box .ant-upload-list .ant-upload-list-item-info {
  padding-right: 28px;
}
.upload-box .ant-upload-list .ant-upload-list-item-info span,
.upload-box .ant-upload-list .ant-upload-list-item-info i {
  color: #007bff;
}
.upload-box .upload-btn {
  border-radius: 50px;
  padding: 0 22px;
  height: 28px;
  border: 2px solid;
  color: #143293;
}
.tw-box .upload-box .upload-btn {
  color: #eb6e23;
}
.upload-box .upload-btn[disabled] {
  color: rgba(0, 0, 0, 0.25) !important;
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
}
.check-payment-box {
  align-items: center;
  // margin-bottom: 10px;
}
.check-payment-box .ant-radio-wrapper {
  color: #000;
  font-size: 1rem;
}
.check-payment-box::v-deep .ant-radio{
  width: 16px;
  height: 16px;
}
.check-box {
  padding-bottom: 15px;
  color: #000;
}
.check-box .ant-radio-wrapper {
  white-space: normal;
  display: flex;
  line-height: normal;
  margin-top: 15px;
}
.check-payment-box ::v-deep .radio-the-check .ant-radio {
  margin-top: 4px;
}

.pamenty-body ::v-deep .check-box .ant-radio-wrapper .ant-radio

.pamenty-body ::v-deep .check-payment-box .ant-radio-wrapper span {
  padding-left: 0;
  margin-right: 4px;
  border-color: #007bff;
}
.check-payment-box > strong {
  font-size: 1.15rem;
  margin-right: 10px;
}
.check-payment-box > p {
  margin: 15px 0 0 0;
}
.check-payment-box .radio-mail-text {
  display: block;
}
.required label:before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
.form-item-special .ant-form-item-control {
  margin-left: 2px;
}
.submitted-successfully h4 {
  text-align: center;
  padding-top: 50px;
  font-size: 24px;
  font-weight: bold;
}
.submitted-successfully .phone-text{
  text-align: center;
  font-size: 1.2rem;
}
#takePicture {
  display: none;
}
.payment-for span:after {
  content: '|';
  padding: 0 5px;
}
.payment-for span:nth-last-of-type(1):after {
  content: none;
}
.btn:hover:before,
.btn:focus:before,
.btn:active:before {
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
}
.loading-box {
  position: relative;
  min-height: 600px;
}
.loading-box img {
  position: absolute;
  top: calc(50% - 0px);
  left: calc(50% - 1px);
  transform: translate(-50%, -50%);
  font-size: 0;
  margin: 0;
}
::v-deep .show-notice .ant-checkbox-inner {
  border: 2px solid red !important;
}
.exp-date-box {
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  font-size: 14px;
  color: red;
}
.card-number-box .number-row {
  font-size: 14px;
  color: #843c0c;
  position: absolute;
  bottom: 18px;
  width: 100%;
}
.payment-for ::v-deep .ant-select-selection{
  border-radius: 0;
  min-width: 200px;
  max-width: 600px;
}
.payment-for ::v-deep .ant-select-selection__rendered{
	line-height: 36px;
}
.payment-for ::v-deep .ant-input-number-input{
    height: 36px !important;
    line-height: 36px;
}
.payment-for ::v-deep .ant-select-selection--multiple .ant-select-selection__rendered > ul > li{
  height: 32px;
  margin-top: 3px;
  line-height: 30px;
  font-size: 14px;
}
.payment-for ::v-deep .ant-select-selection--multiple .ant-select-arrow{
  top:21px;
}
.payment-for strong{
  line-height: 40px;
  width: 135px;
}
.payment-for strong.remaining-balance{
  width: 180px;
  text-align: right;
}
.payment-for .err{
  font-size: 14px;
  color: red;
}
.paid-payment-box{
  border-bottom: 1px #959494 dashed;
  padding-bottom: 20px !important;
  margin-bottom: 20px;
}
.paid-payment-box .title{
  margin-bottom: 5px;
  display: block;
}
.paid-payment-box .nr-table{
  max-width: 500px;
}
.paid-payment-box /deep/ .ant-table-tbody > tr > td{
  color: #000;
  vertical-align: top;
  padding-top: 5px!important;
  padding-bottom: 5px!important;
}
.paid-payment-box /deep/ .ant-table-thead > tr > th{
  background: #f2f2f2 !important;
  font-weight: bold;
  color: #000;
  padding-top: 5px!important;
  padding-bottom: 2px!important;
}
.authorization-box /deep/ .ant-select-selection__placeholder{
  font-weight: 600;
  margin-top: -8px;
  color: #999;
}
input::placeholder {
  color: #999;
  font-weight: 600;
}
.authorization-box /deep/ .ant-select-selection,
.authorization-box /deep/ .ant-input{
  border: 1px solid #7f7f7f;
}

.paid-payment-box /deep/ .ant-table-small{
  border: none;
}
.paid-payment-box /deep/ .ant-table-small > .ant-table-content > .ant-table-body{
  margin: 0;
}
.amount-box{
  margin-top: 8px;
}
.amount-box strong{
  width: 115px;
  text-align: right;
  line-height: 40px;
  padding-right: 6px;
}
.amount-box strong.remaining-balance{
  width: 180px;
  padding-right: 0;
}
.amount-box /deep/ .ant-input{
  height: 40px;
  border-radius: 0;
  max-width: 200px;
}
.amount-box /deep/ .ant-input-number{
  height: 40px;
  width: 100%;
  border-radius: 0;
}
.amount-box /deep/ .ant-input-number-input{
  height: 40px;
  border-radius: 0;
  width: 198px;
}
.top-information{
  margin-bottom: 15px !important;
  border-bottom: 1px #959494 dashed;
  padding-bottom: 10px !important;
}
.top-information .operating{
  font-size: 16px;
  color: #2e9aff;
  cursor: pointer;
}
.top-information .operating i{
  margin-left: 6px;
}
.operating-modal-box ul{
  list-style: none;
  padding: 0;
  margin: 0;
}
.operating-modal-box ul li{
  margin-bottom: 20px;
  border-bottom: 1px #e9e9e9 solid;
  padding-bottom: 20px;
}
.operating-modal-box ul li .img{
  margin: 20px 0;
  text-align: center;
}
.operating-modal-box ul li img{
  max-width: 100%;
  display: inline-block;
  margin: auto;
  box-shadow: 0px 2px 8px #00000040;
}
.operating-modal-box .title{
  display: flex;
}
.operating-modal-box .nr{
  padding-left: 25px;
}
.operating-modal-box.sup-box .nr{
  padding-left: 17px;
}
.operating-modal-box /deep/ .ant-modal-body{
  overflow: auto;
  max-height: 500px;
}
.operating-modal-box /deep/ .ant-modal-body::-webkit-scrollbar{
  width: 7px;
}
.operating-modal-box /deep/ .ant-modal-body::-webkit-scrollbar-button{
  display: none;
}
.operating-modal-box /deep/ .ant-modal-body::-webkit-scrollbar-thumb{
  border-radius: 0;
  background-color: #c1c1c1;
}
.operating-modal-box /deep/ .ant-modal-body::-webkit-scrollbar-track{
  background-color: #f1f1f1;
  box-shadow: none;
}
.payment-amount-number{
  position: relative;
}
.payment-amount-number .type{
  position: absolute;
  z-index: 100;
  color: #000000b8;
  font-size: 14px;
  line-height: 40px;
  padding-left: 10px;
}
.payment-amount-number /deep/ .ant-input-number-input{
  height: 38px;
}
.payment-amount-number.usa /deep/ .ant-input-number-input{
  padding-left: 20px;
}
.payment-amount-number.can /deep/ .ant-input-number-input{
  padding-left: 40px;
}
.sup-li{
  padding-right: 5px;
}
.submission-modal-box .submitting-tip-box .spin{
  text-align: center;
  padding: 15px 0 25px 0;
}
.submission-modal-box /deep/ .ant-modal-content{
  border: 5px #355749a1 solid;
  border-radius: 0;
}
.submission-modal-box.sup-box /deep/ .ant-modal-content{
  border-color: #cec395b0;
}
.submission-modal-box .submitting-tip-box .nr{
  padding-bottom: 15px;
}
.submission-modal-box.sig-box .submitting-tip-box .spin /deep/ .ant-spin-dot-item{
  background: #eb6e23;
}
.submission-modal-box.sig-box .submitting-tip-box .spin /deep/ .ant-spin-text{
  color: #eb6e23;
}
.submission-modal-box.sup-box .submitting-tip-box .spin /deep/ .ant-spin-dot-item{
  background: #143293;
}
.submission-modal-box.sup-box .submitting-tip-box .spin /deep/ .ant-spin-text{
  color: #143293;
}
.authorization-box /deep/ .ant-checkbox-inner{
  border-radius: 0;
}
.authorization-box /deep/ .ant-checkbox-inner, 
.authorization-box /deep/ .ant-radio-inner{
  border: 1px solid #7f7f7f;
}
.paymen-info-box{
  font-size: 17px;
  text-align: left;
  padding: 40px 0;
  border-top: 1px #959494 dashed;
  margin-top: 60px;
}
.paymen-info-box /deep/ .ant-checkbox-checked .ant-checkbox-inner{
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  margin-right: 6px;
  margin-top: -2px;
}
// 中文站
.tw-box .credit-text {
  color: #eb6e23;
}
@media (max-width: 992px) {
  .ant-form-item label {
    margin-bottom: 0;
  }
  .input-height {
    line-height: 100px;
  }
  .card-number-box {
    position: static;
    height: 120px;
  }
  .card-number-box .log-row {
    bottom: 4px;
    padding-left: 4px;
    bottom: 27px;
    top: auto;
  }
  .exp-date-box {
    bottom: 5px;
    left: 4px;
  }
  .exp-date-box .ant-col-10,
  .card-number-box .number-row .ant-col-7 {
    display: none;
  }
  .card-number-box .number-row {
    bottom: 14px;
  }
  .exp-date-box .ant-col-14 {
    width: 100%;
  }
  .card-number-box .log-row .ant-col-7 {
    display: none;
  }
  .booking-box {
    padding-left: 0;
  }
  .booking-box > div {
    padding-bottom: 5px;
  }
  .booking-box > div:nth-last-of-type(1) {
    padding-bottom: 0;
  }
  #takePicture {
    display: inline-block;
  }
}
@media (max-width: 768px){
  .payment-for ::v-deep .ant-select-selection{
    min-width: 100%;
    max-width: 100%;
  }
  .payment-for ::v-deep .ant-select{
    width: 100%;
  }
  .amount-box /deep/ .ant-input{
    max-width: none;
    width: 100%;
  }
  .amount-box > div{
    flex: 1;
  }
  .operating-modal-box ul li .img{
    padding-left: 25px;
  }
  .operating-modal-box.sup-box ul li .img{
    padding-left: 17px;
  }
  .operating-modal-box ul li img{
    width: 100% !important;
  }
  .submitted-successfully h4{
    padding-top: 30px;
  }
}
</style>